export const getGridTemplateColumns = (isIdenticalCamps: boolean) =>
  !isIdenticalCamps ? "minmax(330px, 30%) 15% 14% minmax(26%, auto) 5%" : "auto 30% 22% 5%"
